import React from 'react';

const Voucher = ({ rutaImagen, onDelete, onEdit }) => {
  return (
   <div style={{
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '70vh',
  overflow: 'auto',
  padding: '10px',
  backgroundColor: '#f8f9fa'
}}>
  <img 
    src={rutaImagen} 
    alt="voucher" 
    style={{
      maxWidth: '100%',
      maxHeight: '100%',
      objectFit: 'contain',
      borderRadius: '8px'
    }} 
  />
</div>
  );
};

export default Voucher;